export const brandTitle = {
  type: "string",
  minLength: 1,
  maxLength: 255
};
